var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPenOrange = function SvgIconPenOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "m1.66 8.828 2.21-.442a.417.417 0 0 0 .213-.114l2.771-2.77a.417.417 0 0 0 0-.59L5.086 3.144a.417.417 0 0 0-.589 0l-2.77 2.771a.417.417 0 0 0-.115.213l-.442 2.21a.417.417 0 0 0 .49.49ZM8.414 2.174l-.59-.59a1.25 1.25 0 0 0-1.767 0l-.411.411a.417.417 0 0 0 0 .59l1.768 1.767a.417.417 0 0 0 .589 0l.41-.41a1.25 1.25 0 0 0 0-1.768Z"
  })));
};
export default SvgIconPenOrange;